import { useQuery } from '@tanstack/vue-query'
import { createQuery } from 'QueryKit'
import { getInspectionsFiltered, workcards } from 'API/definitions/iris/inspection-instance'

const useGetInspectionInstancesFiltered = createQuery<any, any, Error>({
  primaryKey: 'inspection-instances_filtered',
  queryFn: ({ queryKey: [primaryKey, variables] }) => {
    return getInspectionsFiltered(variables?.filterQueryParams)
  },
})

const inspectionInstanceWorkCardsQuery = (inspectionInstanceUUID, options?) =>
  useQuery(['inspection-instance', 'workcards', inspectionInstanceUUID], () => workcards(inspectionInstanceUUID), {
    ...options,
  })

export { useGetInspectionInstancesFiltered, inspectionInstanceWorkCardsQuery }
